<svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <use [attr.xlink:href]="'#app-icon-' + iconId"></use>
</svg>